import React from "react";

import ReactHelmet from "../../components/react-helmet/react-helmet";
const Missouriheader = () => {
  return (
    <>
      <ReactHelmet
        title={"Facilities For Sober Living in Missouri | Taste Recovery"}
        description={
          "Browse available facilities for sober living in Missouri offering safe, peer-reviewed & supportive environments to help individuals maintain lasting recovery."
        }
      />
    </>
  );
};

export default Missouriheader;
